export default __webpack_public_path__ + "static/media/IMG_6067 copy.f2d8c819.jpg";